import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { COUPON_PAGE_NAME } from '../../constants/service/app/couponConstants';
import { CouponCreateWrap } from '../../views/coupon-v2/save/CouponSaveWrap';

const CouponCreate = () => {
  return (
    <PageTemplate pageName={COUPON_PAGE_NAME.COUPON_CREATE}>
      <CouponCreateWrap />
    </PageTemplate>
  );
};

export default CouponCreate;
